import {
  AttachFileOutlined,
  KeyboardArrowRightRounded,
  PersonAddOutlined,
  PersonOutline,
} from "@mui/icons-material";
import { Card } from "@mui/material";
import Button from "@mui/material/Button";
import { isNil } from "lodash";
import { memo, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import FlxGrid from "../../../../_src_shared/components/layout/FlxGrid";
// import BorrowerAssociationsSelector from "../../../../components/common/Loan/associations/BorrowerAssociationsSelector";
// import BorrowerAssociationChipList from "../../../../components/common/Loan/associations/components/lists/variants/BorrowerAssociationChipList";
import { yellow } from "@mui/material/colors";
import { DetailSection } from "../../../../_src_shared/common/DetailSection/DetailSection";
import Flx from "../../../../components/layout/Flx";
import ScreenContent from "../../../../components/layout/ScreenContent";
import TitledHeaderWithSearch from "../../../../components/layout/TitledHeaderWithSearch";
import Txt from "../../../../components/typography/Txt";
import SubsectionHeader from "../../../../components/ui/SubsectionHeader";
import { loanDrilldownSidebarTypes } from "../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { useReduxHook } from "../../../../hooks/useReduxHook";
import { sidebarTypeToggle } from "../../../../redux/actions/sidebarActions";
import LoanDocumentGroupFilesCard from "../../shared/LoanDocumentGroupFilesCard";
import LoanDrilldownTabPanel from "../LoanDrilldownTabPanel";
import BorrowerAssociationPane from "./BorrowerAssociationPane";
import BorrowerPreviewOLD from "./BorrowerPreviewOLD";
import LoanBorrowersTable from "./LoanBorrowersTable";
import LoanDrilldownBorrowersTabRedesign from "./LoanDrilldownBorrowersTabRedesign/LoanDrilldownBorrowersTabRedesign";
import RedesignBanner from "../../../../components/ui/RedesignBanner";

const LoanDrilldownBorrowersTab = ({ value, tab }) => {
  const ref = useRef();
  const { borrowerId } = useParams();
  const navigate = useNavigate();
  const { id: loanId } = useParams();
  const [redesign, setRedesign] = useState(false);
  const { isHighLevelUser } = useReduxHook();
  const borrowers = useSelector(
    (state) => state?.loanDrilldown?.borrowers || []
  );

  // Find the selected borrower based on URL parameter
  const selectedBorrower = useMemo(() => {
    if (!borrowerId || !borrowers.length) return null;
    return borrowers.find((borrower) => borrower._id === borrowerId) || null;
  }, [borrowerId, borrowers]);

  // if (redesign && isDev) {
  if (redesign && isHighLevelUser) {
    return (
      <Flx column>
        <LoanDrilldownBorrowersTabRedesign />
        <RedesignBanner show active={redesign} onClick={setRedesign} />
      </Flx>
    );
  }
  return (
    <LoanDrilldownTabPanel>
      <TitledHeaderWithSearch
        title={"Borrowers"}
        endContent={<AddBorrowerButton />}
        borderColor={"#eeeeee"}
      />

      <ScreenContent sx={{ p: 3 }}>
        <SubsectionHeader
          title={"Loan Borrowers"}
          icon={<PersonOutline className="thin" fontSize="small" />}
        />
        <Card
          sx={{
            p: 0,
            overflow: "hidden",
            mb: 3,
          }}
        >
          <LoanBorrowersTable
            rowData={borrowers}
            ref={ref}
            selectedId={selectedBorrower?._id}
          />
        </Card>

        {/* --- PREVIEW AND FILES --- */}
        <Flx wrap fw gap={4} sx={{ mt: 1, flexGrow: 1, flexShrink: 1, px: 0 }}>
          {isNil(selectedBorrower) ? null : (
            <Flx
              className={"left-col"}
              column
              sx={{
                flexShrink: 1,
                flexGrow: 1,
                flexBasis: "800px",
              }}
            >
              <SubsectionHeader
                title={"All Borrowers"}
                onClick={() => navigate(`/loan/${loanId}/borrowers`)}
                icon={<PersonOutline className="thin" fontSize="small" />}
              >
                <KeyboardArrowRightRounded className="thin" />
                <Txt bold>
                  {selectedBorrower?.firstName} {selectedBorrower?.lastName}
                </Txt>
              </SubsectionHeader>
              <BorrowerPreviewOLD selectedId={selectedBorrower?._id} />

              {/* <BorrowerPreview selectedId={selectedBorrower?._id} /> */}
            </Flx>
          )}

          {isNil(selectedBorrower?._id) ? null : (
            <>
              <BorrowerAssociationPane
                show
                // onClose={setShowRelatedItems}
                borrower={selectedBorrower}
              />
              {/* <Flx
                gap={2}
                column
                sx={{
                  flexGrow: 1,
                  flexShrink: 0,
                  flexBasis: "480px",
                  p: 3,
                  borderRadius: 4,
                  background: grey[200],
                  border: `1px solid ${grey[300]}`,
                  alignSelf: "flex-start",
                }}
              >
                <Txt
                  bold
                >{`${selectedBorrower?.firstName} ${selectedBorrower?.lastName} Related Items`}</Txt>
                <Flx column gap={3}>
        
                  <BorrowerAssociationsSection borrower={selectedBorrower} />
                  <BorrowerCommentsSection borrower={selectedBorrower} />
                </Flx>
              </Flx> */}
            </>
          )}
          <AllBorrowerRelatedFilesContent />
        </Flx>
      </ScreenContent>
      <RedesignBanner
        active={redesign}
        onClick={setRedesign}
        show={isHighLevelUser}
      />
    </LoanDrilldownTabPanel>
  );
};

const AllBorrowerRelatedFilesContent = ({ selectedId }) => {
  return (
    <DetailSection
      title={`Related Files (All Borrowers)`}
      collapsible={true}
      defaultExpanded={true}
      icon={<AttachFileOutlined className="thin" fontSize="small" />}
    >
      <FlxGrid wrap gap={2} width="540px">
        <LoanDocumentGroupFilesCard
          showIfEmpty
          hideChart
          showGroupIcon
          docGroup={"Borrower Documents"}
          title={"Borrower Documents"}
        />
        <LoanDocumentGroupFilesCard
          showIfEmpty
          hideChart
          showGroupIcon
          docGroup={"Liquidity"}
          title={"Borrower Liquidity"}
        />
      </FlxGrid>
    </DetailSection>
  );
};

const AddBorrowerButton = memo(() => {
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_BORROWER));
  };

  return (
    <Button
      sx={{ ml: 1 }}
      startIcon={<PersonAddOutlined />}
      onClick={handleToggle}
    >
      Add Borrower
    </Button>
  );
});

export default LoanDrilldownBorrowersTab;
